import { Skeleton } from '@mui/material'
import React from 'react'

const SkeletonRestrictCard = () => {
  return (
    <Skeleton
      variant="rounded"
      animation="wave"
      width={"14.4vw"}
      height={"6.6vw"}
      sx={{
        backgroundColor: "#ededeb",
        borderRadius: " 0.4vw",
      }}
    />
  )
}

export default SkeletonRestrictCard
